// UI store — global frontend chrome state that doesn't fit the auth /
// toast / confirm stores.
//
// Currently just the mobile sidebar drawer. The drawer is an off-canvas
// pattern below the `md` breakpoint (768px) — at desktop widths the
// sidebar is permanently visible and the open/closed state is ignored.

import { create } from "zustand";

interface UiState {
  isSidebarOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleSidebar: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  isSidebarOpen: false,
  openSidebar: () => set({ isSidebarOpen: true }),
  closeSidebar: () => set({ isSidebarOpen: false }),
  toggleSidebar: () => set((s) => ({ isSidebarOpen: !s.isSidebarOpen })),
}));
